import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  display: flex;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.75);
  z-index: ${ (props) => props.theme.zIndices.overlay };
`
